import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  SIGNIN_URL,
  FILE_FORMAT_PDF_IMAGE,
  TROUBLESHOOT_LOGIN,
  TICKET_CREATION_FAILED
} from '../../../utils/constants';
import map from 'lodash/map';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  CommonFileUpload,
  OutlinedTextFields,
  CommonDropdownOutlined,
  TextArea,
  CommonButton
} from '@Components';
import { compileTemplate, disableReturn, getAbsolutePath } from '../../../utils/library';
import { Field, reduxForm, getFormValues, reset } from 'redux-form';
import { required, minLength2, email } from '../../../utils/validation';
import { r_maxLength } from '../../../utils/validation/restrictions';
import PropTypes from 'prop-types';
import { API_URL } from '../../../utils/config';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import {
  FLOW_TYPE_TROUBLE_LOGGING_IN,
  OTHERS_LOGGING_IN,
  OTP_NOT_RECEIVED,
  PASSWORD_RESET
} from '../../../utils/constants/eventsConstants';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import { showMessage } from '@Redux/actions/common-message';
import {
  createZendeskTicketforPublicPage,
  setPublicPageLevelValue
} from '@Redux/actions/help-center-action';
import { encodeToZendeskKeyFormat } from '../../help-center/utils/Utils';
import { logEvent } from '../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../utils/events/eventsConstants';
import { BACK_ARROW_ICON, RIGHT_ARROW_BLACK_ICON, TICKET_SUCCESS_ICON } from '@Images';

const NEW_TICKET = 'NEW_TICKET';

const fieldcustom = {
  document_code: 'FIN',
  document_input_type: 'FILE',
  is_back_required: false,
  label: 'Attachment (if any)',
  show_upload_button: true,
  file_field_name: 'zendesk_attachment'
};

const TextWrapper = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${COLORS.textGrey};
  padding: 16px 0;

  .top-header {
    font-size: 16px;
  }

  .header {
    font-weight: bold;
    font-size: 24px;
    color: ${COLORS.black};
    border-bottom: 1px solid #e8e8e8;
    padding: 20px 0px;
  }

  .sub-header {
    padding-bottom: 100px;
  }

  .footer {
    padding-top: 30px;
  }

  .item {
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    padding: 20px 0px;
    align-items: center;
    cursor: pointer;

    img {
      float: right;
    }
  }

  div {
    padding-top: 15px;
  }
  span {
    font-weight: bold;
    color: ${COLORS.brandPrimary};
    cursor: pointer;
  }
`;

const List = styled.ul`
  list-style: disc;
  padding-left: 25px;
  padding-top: 15px;

  li {
    margin: 10px 0px;
  }
`;

const BackIconDiv = styled.div`
  cursor: pointer;
`;

const Button = styled.div`
  height: 50px;
  outline: none;
  border-radius: 4px;
  border: none;
  width: 100%;
  margin-top: ${(props) => props.marginTop};
  background-color: ${COLORS.brandPrimary};
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.white};
    text-decoration: none;
    &:hover {
      text-decoration: none;
      color: ${COLORS.white};
    }
  }
  &:hover {
    background-color: ${COLORS.brandPrimaryHover};
  }
`;

const InputBox = styled.div`
  padding: 5px 0px;

  .input-header {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold} !important;
    color: ${COLORS.black};
  }
  #error-msg {
    font-size: 11px;
    line-height: 16px;
    font-family: ${FONT_FAMILY.hellix.regular};
  }
`;

const TextAreaField = styled.div`
  padding: 5px 0px;

  .input-header {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold} !important;
    color: ${COLORS.black};
    padding-top: 5px;
  }

  .text-area {
    margin-top: 5px;

    textarea {
      ::-webkit-input-placeholder {
        color: #a9a9a9 !important;
      }
    }
  }
`;

const CountryDropdown = styled.div`
  padding: 5px 0px 5px 0px;
`;

const TicketSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;
  padding: 0px 20px;
  text-align: center;
  padding-top: 25px;
  font-size: 16px;

  .header {
    font-weight: bold;
    font-size: 24px;
    color: ${COLORS.black};
  }

  .sub-header {
    font-weight: bold;
    color: ${COLORS.black};
  }
`;

function Social(props) {
  const [selectedSection, setSection] = useState({});
  const [actionData, setActionData] = useState({});
  const { loggingIssueContent, formValues } = props;

  const navigate = (fields) => {
    setSection(fields);
  };

  const back = () => {
    setSection({});
    setActionData({});
  };

  const performAction = (data) => {
    setActionData(data);
  };

  const createTicket = async (data) => {
    props.activateLoader();
    const groupId = get(loggingIssueContent, 'GroupId.target.fields.zendeskId.value', '');
    const ticketSubjectLine = get(
      loggingIssueContent,
      'fdSubjectArray.value.default',
      'Trouble logging in'
    );

    const result = get(
      await props.createZendeskTicketforPublicPage({
        ...data,
        priority: ticketPriority.toLowerCase(),
        subject: props.publicPageLevelValue || ticketSubjectLine,
        groupId: groupId,
        level_1:
          encodeToZendeskKeyFormat(`trouble_logging_in__${props.publicPageLevelValue}`) ||
          'trouble_logging_in__other_issue'
      }),
      'data.data',
      {}
    );
    if (!isEmpty(result)) {
      setActionData({ screen: 'TICKET_SUCCESS', data: result });
      props.disableLoader();
    } else {
      props.disableLoader();
      props.dispatch(showMessage({ text: [TICKET_CREATION_FAILED], type: 'error' }));
    }
  };

  const renderFields = (ticketDataFieldsJSON) => {
    return ticketDataFieldsJSON.map((item, _index) => {
      const validate = [];
      if (item.required) {
        validate.push(required);
      }
      if (item.isEmailField) {
        validate.push(email);
      }
      if (item.name === 'fcnrQueryType') {
        return null;
      }
      switch (item.type) {
        case 'text':
          return (
            <InputBox>
              <Field
                name={item.name}
                type="text"
                key={item.name}
                component={OutlinedTextFields}
                normalize={r_maxLength(item.maxLength || 50)}
                maxWidth={'100%'}
                validate={validate}
                placeholder={item.placeholder}
              />
            </InputBox>
          );
        case 'dropdown':
          return (
            <CountryDropdown>
              <Field
                bindToThisObject={formValues[item.name]}
                name={item.name}
                dependedOnObject={formValues[item.name]}
                type="text"
                key={item.name}
                component={CommonDropdownOutlined}
                placeholder={item.label}
                selectOnClose={true}
                validate={validate}
                width={'100%'}
                className="theme-dropdown"
                staticValues={!isEmpty(item.staticValues) ? item.staticValues : ''}
                url={item.url ? `${API_URL}${item.url}` : ''}
              />
            </CountryDropdown>
          );
        case 'text-area':
          return (
            <TextAreaField>
              <div className="input-header">{item.label}</div>
              <Field
                name={item.name}
                type="text"
                key={item.name}
                rows={item.rows || 4}
                component={TextArea}
                parentClass="text-area"
                validate={[...[minLength2], ...validate]}
                label={item.label}
                placeholder={item.placeholder}
              />
            </TextAreaField>
          );
        case 'file':
          return (
            <div>
              <CommonFileUpload
                currentScreen={props.currentScreen}
                formName={NEW_TICKET}
                validate={FILE_FORMAT_PDF_IMAGE}
                key={item.name}
                fieldscustom={{
                  ...fieldcustom,
                  ...{
                    label: item.label,
                    file_field_name: item.name,
                    is_mandatory: item.required || false
                  }
                }}
                showSampleImageFlag={false}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  const sectionName = get(selectedSection, 'action.value', '');
  const sectionButtonField = get(selectedSection, 'button.target.fields', {});
  const sectionHeader = get(selectedSection, 'header.value', '');
  const sectionFooter = get(selectedSection, 'footer.value', '');
  const sectionNote = get(selectedSection, 'note.value', '');
  const buttonText = get(sectionButtonField, 'label.value', '');
  const buttonRedirection = get(sectionButtonField, 'redirectionLink.value', '#');
  const buttonAction = get(sectionButtonField, 'action.value', '');
  const sectionList = get(selectedSection, 'list.value', []);
  const sectionSubHeader = get(selectedSection, 'subHeader.value', '');
  const ticketDataFields = get(loggingIssueContent, 'supportingDocument.target.fields', {});
  const ticketDataFieldsHeader = get(ticketDataFields, 'header.value', '');
  const ticketDataFieldsJSON = get(ticketDataFields, 'fieldJson.value.fields', []);
  const ticketPriority = get(ticketDataFields, 'fieldJson.value.priority', 'normal');

  const ticketDataSubmitButtonText = get(
    ticketDataFields,
    'submitButton.target.fields.label.value',
    ''
  );
  const successHeading = get(loggingIssueContent, 'loginSuccessHeading.value', '');
  const successDesc = get(loggingIssueContent, 'loginSuccessDescription.value', '');
  const successButtonText = get(loggingIssueContent, 'loginSuccessButtonText.value', '');
  const successSubHeading = get(loggingIssueContent, 'loginSuccessSubHeader.value', '');

  const getEventName = (value) => {
    switch (value) {
      case TROUBLESHOOT_LOGIN.forgotPasswordText:
        return PASSWORD_RESET;
      case TROUBLESHOOT_LOGIN.otpNotReceived:
        return OTP_NOT_RECEIVED;
      case TROUBLESHOOT_LOGIN.otherIssuesText:
        return OTHERS_LOGGING_IN;
      default:
        return '';
    }
  };

  return (
    <div className="auth_container_form social_error_screen">
      <div>
        {'TICKET_SUCCESS' !== actionData.screen &&
          (!sectionName && !['TICKET_CREATION'].includes(actionData.screen) ? (
            <Link
              to={SIGNIN_URL}
              onClick={() => {
                props.dispatch(reset(NEW_TICKET));
                props.hideTroubleLoggingScreen();
              }}
            >
              <img src={BACK_ARROW_ICON} alt="go-back" width="20px" height="15px" />
            </Link>
          ) : (
            <BackIconDiv
              onClick={() => {
                props.dispatch(reset(NEW_TICKET));
                back();
              }}
            >
              <img src={BACK_ARROW_ICON} alt="go-back" width="20px" height="15px" />
            </BackIconDiv>
          ))}
      </div>
      {!sectionName && !['TICKET_SUCCESS', 'TICKET_CREATION'].includes(actionData.screen) && (
        <TextWrapper>
          <div className="header">{loggingIssueContent['heading']['value']}</div>
          <div className="sub-header">
            {map(loggingIssueContent['options']['value'], (item, index) => {
              const fields = item.target.fields;
              const action = get(fields, 'action.value', '');
              return (
                <div
                  key={index}
                  className="item"
                  onClick={() => {
                    props.setPublicPageLevelValue(fields['label']['value']);
                    logEvent(
                      getEventName(fields['label']['value']),
                      FLOW_TYPE_TROUBLE_LOGGING_IN,
                      {},
                      LOG_TYPE.CLEVER_TAP
                    );
                    if (action === 'TICKET_CREATION') {
                      performAction({ screen: action });
                    } else {
                      navigate(fields);
                    }
                  }}
                >
                  {fields['label']['value']}
                  <img src={RIGHT_ARROW_BLACK_ICON} alt="go-next" width="20px" height="15px" />
                </div>
              );
            })}
          </div>
        </TextWrapper>
      )}
      {['RESET_PASSWORD', 'OTP_SUPPORT'].includes(sectionName) && isEmpty(actionData) && (
        <>
          <TextWrapper>
            {sectionHeader && <div>{sectionHeader}</div>}
            {sectionSubHeader && <div>{sectionSubHeader}</div>}
            <List>
              {map(sectionList, (item, index) => {
                return <li key={index}>{item}</li>;
              })}
            </List>
            {sectionFooter && <div className="footer">{sectionFooter}</div>}
            {sectionNote && (
              <CommonButton
                text={sectionNote}
                type="link"
                fontFamily={FONT_FAMILY.hellix.regular}
                fontSize="14"
                onClick={() => {
                  performAction({ screen: 'TICKET_CREATION' });
                }}
              />
            )}
          </TextWrapper>
          {!isEmpty(sectionButtonField) && buttonText && !buttonAction && (
            <Button marginTop={sectionName === 'RESET_PASSWORD' ? '70px' : '30px'}>
              <Link
                className={'new-cus-btn-default cus-btn-reset cus-btn-filled cus-button-link'}
                to={getAbsolutePath(buttonRedirection)}
                onClick={() => {
                  props.dispatch(reset(NEW_TICKET));
                  props.hideTroubleLoggingScreen();
                }}
              >
                {' '}
                <strong>{buttonText}</strong>
              </Link>
            </Button>
          )}
          {!isEmpty(sectionButtonField) && buttonText && buttonAction && (
            <Button marginTop={sectionName === 'RESET_PASSWORD' ? '70px' : '30px'}>
              <Link
                className={'new-cus-btn-default cus-btn-reset cus-btn-filled cus-button-link'}
                to={'#'}
                onClick={() => {
                  performAction({ screen: buttonAction });
                }}
              >
                {' '}
                <strong>{buttonText}</strong>
              </Link>
            </Button>
          )}
        </>
      )}
      <div>
        {'TICKET_CREATION' === actionData.screen && !isEmpty(ticketDataFields) && (
          <form
            onSubmit={props.handleSubmit(createTicket)}
            className="common-form"
            encType="multipart/form-data"
            id="form-zendesk-ticket"
            onKeyUp={disableReturn}
            onKeyPress={disableReturn}
          >
            {ticketDataFieldsHeader && (
              <TextWrapper>
                <div className="top-header">{ticketDataFieldsHeader}</div>
              </TextWrapper>
            )}
            {!isEmpty(ticketDataFieldsJSON) && renderFields(ticketDataFieldsJSON)}
            <CommonButton
              text={ticketDataSubmitButtonText}
              width={380}
              height={50}
              margin="70px 0 0"
              id="submit"
            />
          </form>
        )}
        {'TICKET_SUCCESS' === actionData.screen && (
          <TicketSuccess>
            <div>
              <img src={TICKET_SUCCESS_ICON} alt="success ticket" />
            </div>
            {successHeading && <div className="header">{successHeading}</div>}
            {successSubHeading && (
              <div className="sub-header">
                {compileTemplate(successSubHeading, {
                  ticket_id: actionData?.data?.ticket?.id
                })}
              </div>
            )}
            {successDesc && <div>{successDesc}</div>}
            <Link
              to={SIGNIN_URL}
              className="link"
              onClick={() => {
                props.dispatch(reset(NEW_TICKET));
                props.hideTroubleLoggingScreen();
              }}
            >
              {' '}
              {successButtonText && <strong>{successButtonText}</strong>}
            </Link>
          </TicketSuccess>
        )}
      </div>
    </div>
  );
}

const ReduxFormCreateTicket = reduxForm({ form: NEW_TICKET })(Social);
function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      helpCenterReducer: { publicPageLevelValue }
    }
  } = reduxState;
  const formValues = getFormValues(NEW_TICKET)(reduxState) || {};
  return { formValues, publicPageLevelValue };
}

Social.propTypes = {
  loggingIssueContent: PropTypes.any,
  dispatch: PropTypes.func,
  createZendeskTicketforPublicPage: PropTypes.func,
  handleSubmit: PropTypes.any,
  currentScreen: PropTypes.any,
  formValues: PropTypes.any,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  hideTroubleLoggingScreen: PropTypes.func,
  setPublicPageLevelValue: PropTypes.func,
  publicPageLevelValue: PropTypes.string
};

export default connect(mapStateToProps, {
  setPublicPageLevelValue,
  createZendeskTicketforPublicPage,
  activateLoader,
  disableLoader
})(ReduxFormCreateTicket);
